import { CurrencyValue, HugValue, NumberValue, PercentageValue, HashedNumberValue } from '@/components/tableElements';
import FlexRow from '@/components/FlexRow.vue';
import { mapState } from 'vuex';
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
export default {
  name: "ProductTableTotal",
  mixins: [LiteTableMixin],
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    total: {
      type: Object,
      default: () => ({})
    },
    currencyConfig: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    evolutionType: {
      type: String
    }
  },
  data() {
    return {
      evolCategory: {
        prev_period: "_vs_previous_period",
        same_period_ly: "_vs_previous_year"
      }
    };
  },
  components: {
    CurrencyValue,
    HugValue,
    NumberValue,
    PercentageValue,
    FlexRow,
    EvolutionValue,
    SlotWithEvolutionValue,
    HashedNumberValue
  },
  computed: {
    ...mapState({
      periodCategory: state => state.dsp_report.periodCategory,
      groupBy: state => state.dsp_report.product_table.group_by_text,
      currentTabValue: state => state.dsp_report.currentTabValue
    })
  },
  methods: {
    isTotalColumn(field) {
      return ['seller_name', 'sales_channel', 'line_item_id', 'order_id', 'dsp_overview_campaign_goal'].includes(field.key);
    },
    getJustify(field) {
      return ['dsp_spend', 'dsp_atc_clicks', 'dsp_dpv_clicks', 'dsp_post_click_purch', 'dsp_overview_budget', 'dsp_overview_spend', 'dsp_overview_delivery_rate', 'dsp_overview_objective', 'dsp_overview_cpa', 'dsp_overview_optimization_kpi', 'dsp_overview_assisted_sales', 'dsp_overview_assisted_units_sold'].includes(field.key) ? 'right' : 'left';
    }
  }
};